/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onSavePoints } from "../../Store/Slices/cardDataSlice";
import { getMinPrice } from "../../Common/HOC/Hoc";
import img from "../../Assets/is.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { ClientInfo, getValidDenominations } from "../Utility/Utility";

function SelectCard({
  updatedData,
  productReducer,
  setEarnPoints,
  points,
  convenienceFee,
  gst,
}) {
  const translation = getTranslationData();
  const dispatch = useDispatch();
  const priceDenomination = getValidDenominations(productReducer?.productReducerDisocount?.clientProductDenomination.map(deno => deno.denomination));
  const selectedPriceDenomination = productReducer?.productReducerDisocount?.clientProductDenomination.map(deno => deno.denomination)
  const discount = productReducer?.productReducerDisocount?.customerDiscount;
  const cardData = JSON.parse(sessionStorage.getItem("accountData"));
  const cardInfo = JSON.parse(sessionStorage.getItem("cardInfo"));
  const Updatedcard = useSelector((state) => state.cardDataSliceReducer);

  const mergedArray = useMemo(
    () =>
      cardData?.map((item1) => {
        const matchingItem = cardInfo?.find(
          (item2) => item2.identifier === item1.subIdentifier
        );
        return {
          ...item1,
          ...(matchingItem ? { cardDetails: matchingItem } : {}),
        };
      }),
    [cardData, cardInfo]
  );

  const creditCards = useMemo(
    () =>
      mergedArray?.filter(
        (card) => card?.cardDetails?.identifiertype === "1002"
      ),
    [mergedArray]
  );

  // Initialize selectedCard with the value from localStorage or default to the first card
  const [selectedCard, setSelectedCard] = useState(
    () =>
      sessionStorage.getItem("selectedCard") ||
      creditCards?.[0]?.cardDetails?.CardTypeName ||
      null
  );

  useEffect(() => {
    if (selectedCard) {
      sessionStorage.setItem("selectedCard", selectedCard);
    }
  }, [selectedCard]);

  const minEarn = productReducer?.productReducer?.minEarnPoints;

  const handleCardChange = (card) => {
    setSelectedCard(card);
  };

  let totalDenomination = 0;
  let totalQuantity = 0;
  let totalPayableAmount = 0;

  updatedData?.forEach((item) => {
    totalDenomination += item.denomination * item.quantity;
    totalQuantity += item.quantity;
    totalPayableAmount += item.you_pay * item.quantity;
  });

  const capitalizeFirstLetter = (str) => {
    return str
      ?.split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  };
  const handlePointsChange = (card) => {
    dispatch(
      onSavePoints({
        points: Math.round(card?.memberBalance?.pointBalance),
        identifierType: card?.identifierType,
        subIdentifier: card?.subIdentifier,
      })
    );
  };

  const earnPoints = () => {
    var earn = Math.round(
      (totalDenomination - (totalDenomination * discount) / 100 +
        Number(convenienceFee || 0) + Number(gst || 0)) *
      (minEarn / getMinPrice(selectedPriceDenomination))
    ).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    setEarnPoints(earn);
    return earn;
  };
  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find((item) => item.configKey.toLowerCase() === "isearnview")?.configValue;
  const isEarn = clientConfigurations?.find((item) => item.configKey.toLowerCase() === "isearn")?.configValue;
  //console.log(productReducer, "productReducer");

  return (
    <div id="selectCardContainer" className="selectCardContainer">
      {!minEarn <= 0 &&
        <>
          {(totalDenomination - (totalDenomination * discount) / 100 +
            Number(convenienceFee || 0) + Number(gst || 0)) *
            (minEarn / getMinPrice(priceDenomination)) !==
            0 && (
              (isEarnView || isEarn) ? (isEarnView !== "2" || isEarn !== "2") && <div className={`points ${points === 0 && "jcSb"}`}>
                {points === 0 ? (
                  <p>{translation?.pointsEarn}</p>
                ) : (
                  <>
                    <img className="img mar2" src={img} alt="img" />

                    <p>{translation?.pointsEarnedPayment}</p>
                  </>
                )}
                {points === 0 ? (
                  <span className="points-value d-flex align-item-center">
                    {earnPoints()} {translation?.pts}
                  </span>
                ) : (
                  " "
                )}
              </div> : <>{earnPoints()} {translation?.pts}</>
            )}
        </>
      }

    </div>
  );
}

export default SelectCard;
